import React from 'react';
import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import { Switch, FormControlLabel, FormGroup } from '@mui/material';

// ----------------------------------------------------------------------

FormSwitch.propTypes = {
  name: PropTypes.string,
};

export default function FormSwitch({
  disabled = false,
  name,
  label,
  ...other
}) {
  const { control } = useFormContext();

  return (
    <FormGroup>
      <FormControlLabel
        disabled={disabled}
        label={label}
        control={
          <Controller
            name={name}
            control={control}
            render={({ field }) => <Switch {...field} checked={field.value} />}
          />
        }
        {...other}
      />
    </FormGroup>
  );
}
